// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_ProfileMenuMiddle__ceQTi {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 15px 0;
  width: 100%;
}

.styles_ProfileMenuMiddle__ceQTi p {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #898989;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_checkMarkStyle__2wwFw {
  width: 20px;
  height: 20px;
}

.styles_checkMarkStyle__2wwFw > input {
  display: none;
}

.styles_labelStyle__4JkJU {
  padding: 0 !important;
}

.styles_checkMarkStyle__2wwFw:after {
  left: 7px !important;
  top: 4px !important;
  width: 4px !important;
  height: 8px !important;
  border: solid white !important;
  border-width: 0 3px 3px 0 !important;
  transform: rotate(45deg) !important;
}

.styles_ProfileMenuMiddle__ceQTi .styles_color__tCume {
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  cursor: pointer;
}

.styles_unActive__CJu5V {
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  position: relative;
}

.styles_activeColor__lqGhg {
  border-radius: 50%;
  position: relative;
}

.styles_ProfileMenuBottom__Fjzdi {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px 0;
  width: 100%;
  height: auto;
}

.styles_ProfileMenuBottom__Fjzdi > div,
.styles_ProfileMenuBottom__Fjzdi a {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  border-radius: 4px;
  padding: 6px 5px;
  width: 100%;
  cursor: pointer;
}

.styles_ProfileMenuBottom__Fjzdi > div > span,
.styles_ProfileMenuBottom__Fjzdi > a > span {
  padding-right: 4px;
}

.styles_ProfileMenuBottom__Fjzdi > div:hover,
.styles_ProfileMenuBottom__Fjzdi > a:hover {
  background: #e8e8e8;
}

.styles_singleItem__-gcZ7 {
  margin-bottom: 50px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/LanguageBox/styles.module.scss"],"names":[],"mappings":"AAGE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AAFJ;;AASE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EAEA,eAAA;EACJ,kBAAA;EACA,gBAAA;EACA,mBAAA;AAPA;;AASE;EACE,WAAA;EACA,YAAA;AANJ;;AAQE;EACE,aAAA;AALJ;;AAOE;EACE,qBAAA;AAJJ;;AAME;EACE,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,8BAAA;EACA,oCAAA;EACA,mCAAA;AAHJ;;AAME;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,eAAA;AAJJ;;AAOE;EAKE,oCAAA;EACA,kBAAA;EACA,kBAAA;AARJ;;AAuBE;EAIE,kBAAA;EACA,kBAAA;AAvBJ;;AAuCE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AApCJ;;AAuCE;;EAEE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AArCJ;;AAwCE;;EAEE,kBAAA;AArCJ;;AAwCE;;EAEE,mBAAA;AArCJ;;AAwCE;EACE,mBAAA;AArCJ","sourcesContent":["\n\n\n  .ProfileMenuMiddle {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding: 15px 0;\n    width: 100%;\n    // color: #000;\n\n\n    // border-bottom: 1px solid #d2d2d2;\n  }\n  \n  .ProfileMenuMiddle p {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 20px;\n    text-align: center;\n    color: #898989;\n\n    font-size: 15px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n  }\n  .checkMarkStyle{\n    width:20px;\n    height:20px;\n  }\n  .checkMarkStyle>input{\n    display: none;\n  }\n  .labelStyle{\n    padding: 0 !important;\n  }\n  .checkMarkStyle:after{\n    left: 7px !important;\n    top: 4px  !important;\n    width: 4px !important;\n    height: 8px !important;\n    border: solid white !important;\n    border-width: 0 3px 3px 0 !important;\n    transform: rotate(45deg) !important;\n\n  }\n  .ProfileMenuMiddle .color {\n    box-sizing: border-box;\n    width: 18px;\n    height: 18px;\n    border-radius: 50% ;\n    // margin: 8px 2px;\n    cursor: pointer;\n  }\n  \n  .unActive {\n    // border: 1px solid #dddddd;\n    // outline: 1px solid gray;\n    // outline-offset: 1px;\n    // box-shadow: 0px 0px 0px 1px gray;\n    border: 1px solid rgba(0, 0, 0, 0.50);\n    border-radius:50%;\n    position:relative;\n  }\n  // .unActive::after {\n  //   position: absolute;\n  //   top: -1px;\n  //   content: '';\n  //   left: -1px;\n  //   width: 20px;\n  //   height: 20px;\n  //   border: 1px solid gray;\n  //   border-radius: 40px;\n  //   background-color: transparent;\n  //   display: inherit;\n  // }\n  \n  .activeColor {\n    // outline: 2px solid #d8000d;\n    // outline-offset: 2px;\n    // box-shadow: 0px 0px 0px 1px #d8000d;\n    border-radius:50%;\n    position:relative;\n  \n  }\n  // .activeColor::after {\n  //   position: absolute;\n  //   top: -1px;\n  //   content: '';\n  //   left: -1px;\n  //   width: 20px;\n  //   height: 20px;\n  //   border: 1px solid #d8000d;\n  //   border-radius: 40px;\n  //   background-color: transparent;\n  //   display: inherit;\n  // }\n  \n  .ProfileMenuBottom {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding: 8px 0;\n    width: 100%;\n    height: auto;\n  }\n  \n  .ProfileMenuBottom > div,\n  .ProfileMenuBottom a {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 20px;\n    text-align: center;\n    // color: rgba(0, 0, 0, 0.54);\n    border-radius: 4px;\n    padding: 6px 5px;\n    width: 100%;\n    cursor: pointer;\n  }\n  \n  .ProfileMenuBottom > div > span,\n  .ProfileMenuBottom > a > span {\n    padding-right: 4px;\n  }\n  \n  .ProfileMenuBottom > div:hover,\n  .ProfileMenuBottom > a:hover {\n    background: #e8e8e8;\n  }\n  \n  .singleItem{\n    margin-bottom :50px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ProfileMenuMiddle": `styles_ProfileMenuMiddle__ceQTi`,
	"checkMarkStyle": `styles_checkMarkStyle__2wwFw`,
	"labelStyle": `styles_labelStyle__4JkJU`,
	"color": `styles_color__tCume`,
	"unActive": `styles_unActive__CJu5V`,
	"activeColor": `styles_activeColor__lqGhg`,
	"ProfileMenuBottom": `styles_ProfileMenuBottom__Fjzdi`,
	"singleItem": `styles_singleItem__-gcZ7`
};
export default ___CSS_LOADER_EXPORT___;
